import { lazy } from "react";
import { Navigate, Outlet } from "react-router";
import { PLANS } from "src/CONSTANTS";
import PlanConfirm from "src/components/plan-confirm";
import useAuth from "src/hooks/useAuth";
import Loadable from "../Loadable";

const Register = Loadable(
  lazy(() => import("src/components/tree/components/addUser/index"))
);
const BinaryTree = Loadable(
  lazy(() => import("src/pages/user/genealogy/binary/index"))
);

const BinaryLeg = Loadable(
  lazy(() => import("src/pages/user/genealogy/binaryLeg/index"))
);

const Sponsor = Loadable(
  lazy(() => import("src/pages/user/genealogy/sponsor/index"))
);

const Affiliate = Loadable(
  lazy(() => import("src/pages/user/genealogy/affiliate/index"))
);

const Matrix = Loadable(
  lazy(() => import("src/pages/user/genealogy/matrix/index"))
);
const List = Loadable(
  lazy(() => import("src/pages/user/genealogy/communitylist/index"))
);
const OrbitView = Loadable(
  lazy(() => import("src/pages/user/genealogy/orbitView/index"))
);

const Tree = Loadable(
  lazy(() => import("src/pages/user/genealogy/tree/index"))
);

const MonoLine = Loadable(
  lazy(() => import("src/pages/user/genealogy/mono-line/index"))
);
const HoldingTank = Loadable(
  lazy(() => import("src/pages/user/genealogy/holding-tank/index"))
);


const BinaryVolume = Loadable(
    lazy(() => import("src/pages/user/genealogy/binary-volume-history/index"))
);
const BillingReport = Loadable(
    lazy(() => import("src/pages/user/genealogy/billingReport/index"))
);

// const Communitylist = Loadable(
//   lazy(() => import("src/pages/user/genealogy/communitylist/index"))
// );

const { binary, matrix, roi, uniLevel, monoLine } = PLANS;

const RequireActivePackage = () => {
  const { user } = useAuth();
  const activeStatus = user?.activePackageStatus;

  if (activeStatus === false) {
    return <Navigate to="/user/billing" replace />;
  }

  return <Outlet />;
};

const getPath = () => {
  const plan = localStorage.getItem("plan");

  switch (plan) {
    case binary: {
      return "binary";
    }

    case uniLevel: {
      return "sponsor";
    }

    case matrix: {
      return "matrix";
    }

    default: {
      return "binary";
    }
  }
};

const genealogy = {
  path: "genealogy",
  element: <RequireActivePackage />,
  children: [
    { index: true, element: <Navigate to={getPath()} /> },
    {
      path: "binaryLeg",
      element: (
        <PlanConfirm types={[binary, roi]}>
          <BinaryLeg />
        </PlanConfirm>
      ),
    },
    { path: "register", element: <Register /> },
    {
      path: "matrix",
      element: (
        <PlanConfirm types={[matrix]}>
          <Matrix />
        </PlanConfirm>
      ),
    },
    {
      path: "orbitView",
      element: (
        <PlanConfirm types={[uniLevel]}>
          <OrbitView />
        </PlanConfirm>
      ),
    },
    {
      path: "mono-line",
      element: (
        <PlanConfirm types={[monoLine]}>
          <MonoLine />
        </PlanConfirm>
      ),
    },

    // {
    //   path: "binary",
    //   element: (
    //     <PlanConfirm types={[binary, roi]}>
    //       <BinaryTree />
    //     </PlanConfirm>
    //   ),
    // },
    { path: "sponsor", element: <Sponsor /> },
    { path: "affiliate", element: <Affiliate /> },
    { path: "list", element: <List /> },
    { path: "tree", element: <Tree /> },
    { path: "holding-tank", element: <HoldingTank /> },
    { path: "volume-binary", element: <BinaryVolume /> },
    { path: "billingreport", element: <BillingReport /> },
  ],
};

export default genealogy;
